import { jsx as o } from "react/jsx-runtime";
import { cva as n } from "class-variance-authority";
import { cn as i } from "../../utils.js";
const c = n(
  "inline-block w-fit rounded border text-button transition-colors ",
  {
    variants: {
      size: {
        sm: "px-1 py-0.25",
        md: "px-1.5 py-0.5"
      },
      color: {
        primary: "border-transparent bg-primary-50 text-primary-600",
        secondary: "border-transparent bg-secondary-50 text-secondary-600",
        success: "border-transparent bg-success-50 text-success-600",
        warning: "border-transparent bg-warning-50 text-warning-600",
        critical: "border-transparent bg-critical-50 text-critical-600",
        onSurface: "border-transparent bg-onSurface-100 text-onSurface-600",
        one: "border-transparent bg-decorative-one-50 text-decorative-one-100",
        two: "border-transparent bg-decorative-two-50 text-decorative-two-100",
        three: "border-transparent bg-decorative-three-50 text-decorative-three-100",
        four: "border-transparent bg-decorative-four-50 text-decorative-four-100"
      }
    },
    defaultVariants: {
      color: "primary"
    }
  }
);
function p({
  className: r,
  color: t = "primary",
  size: e = "sm",
  ...a
}) {
  return /* @__PURE__ */ o("div", { className: i(c({ color: t, size: e }), r), ...a });
}
export {
  p as Tag,
  c as tagVariants
};
